import script from "./PIDTrackingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PIDTrackingPage.vue?vue&type=script&setup=true&lang=js"

import "./PIDTrackingPage.vue?vue&type=style&index=0&id=07e5b3be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e5b3be"]])

export default __exports__